var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 2.49901H7.50097C6.838 2.49901 6.20217 2.76243 5.73338 3.2313C5.26459 3.70018 5.00122 4.33612 5.00122 4.99921V25.0008C5.00122 25.6639 5.26459 26.2998 5.73338 26.7687C6.20217 27.2376 6.838 27.501 7.50097 27.501H22.4995C23.1624 27.501 23.7983 27.2376 24.2671 26.7687C24.7358 26.2998 24.9992 25.6639 24.9992 25.0008V9.99961M17.5 2.49901C17.8956 2.49837 18.2875 2.57602 18.653 2.72749C19.0185 2.87896 19.3505 3.10126 19.6298 3.38158L24.1143 7.86694C24.3953 8.14635 24.6182 8.47867 24.7701 8.84472C24.922 9.21077 24.9999 9.60329 24.9992 9.99961M17.5 2.49901V8.74951C17.5 9.08105 17.6317 9.39902 17.866 9.63346C18.1004 9.8679 18.4184 9.99961 18.7498 9.99961L24.9992 9.99961M12.5005 11.2497H10.0007M19.9997 16.2501H10.0007M19.9997 21.2505H10.0007",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileText);
export default __webpack_public_path__ + "static/media/icon_file_text.e90c231d6f8f0b0c42c818339f3a360d.svg";
export { ForwardRef as ReactComponent };